import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { BaseDialog, ItemWrapper } from '../../../styles/common/Dialog';

export const Dialog = styled(BaseDialog)`
  width: 680px;
  @media (max-height: 716px) {
    height: 540px;
    overflow-y: auto;
  }
  background-color: ${ColorSF2.whisperGray};
`;

export const BodyBlock = styled.div`
  margin-bottom: 10px;
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  @media (max-height: 530px) {
    margin: 10px 0;
  }
`;

export const EnhancedItemWrapper = styled(ItemWrapper)`
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  margin: 0 10px;
`;

export const InfoTitle = styled.div`
  flex: 0 0 120px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  align-items: center;
  padding-left: 10px;
`;
export const InfoBody = styled.div`
  width: 100%;
  background-color: ${ColorSF2.white};
  display: flex;
  align-items: center;
  padding-left: 10px;
  flex-wrap: wrap;
  word-break: break-all;
`;

export const StyledSelect = styled.select`
  width: 500px;
  height: 32px;
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 4px;
  padding: 5px;
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const InputWrapper = styled.div`
  width: 500px;
`;
